<template>
  <q-card class="full-width" :class="[$q.dark.isActive ? 'bg-grey-8' : 'bg-grey-1']" flat bordered>
    <q-card-section>
      <div class="row items-center justify-between">
        <div class="row q-gutter-x-sm">
          <q-avatar color="indigo-1" text-color="primary" size="32px">
            <span style="font-weight: 500">{{
              name.split(' ')[0][0] + name.split(' ')[1][0]
            }}</span>
          </q-avatar>
          <div style="font-size: 1.2rem" class="q-ml-sm">
            <i v-for="i in 5" :key="i" class="material-icons text-yellow-8"> star_rate </i>
          </div>
        </div>
        <div style="padding-top: 4px">
          <b>{{ name }}</b>
        </div>
      </div>
      <div
        class="q-mt-md"
        :class="[$q.dark.isActive ? 'text-grey-3' : 'text-grey-9']"
        style="font-size: 0.8rem"
      >
        "{{ quote }}"
      </div>
    </q-card-section>
  </q-card>
</template>
<script lang="ts">
export default {
  name: 'QuoteCard',
  props: {
    quote: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    }
  }
}
</script>
